import { Store } from 'react-notifications-component';

const showNotification = function(title, type, message){
  Store.addNotification({
        title: title,
        message: message,
        type: type,
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
}


const noDismissNotification = function(title, type, message){
  Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-full",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"]
    });
}


export {showNotification, noDismissNotification};

//https://teodosii.github.io/react-notifications-component/


// Container
// Container can be set from predefined values top-left, top-right, top-center, bottom-left, bottom-right, bottom-center

// Type
// Type can be set from predefined values success, default, warning, info, danger or custom to suit your needs